module.exports = __webpack_public_path__ + "img/amxmodules.5337b8bf.webp";